import styled from "styled-components";
import { Colors, TextFont } from "../../config";
import Box from "../Box";
// import InputField from "../InputField";
// import Table from "../Table";
import { HeaderWrapper } from "../../pages/ConfirmBookingStatus";
import ConfirmRequestAccordion from "../../pages/ConfirmBookingStatus/ConfirmRequestAccordion";
import { getFormattedTravellerDetails } from "../../helper";
import { useExtraFieldsContext } from "../../contexts/ExtraFieldsContext";

const TravellerDetails = ({
  confirmFlightLocationUrl,
  guestTicketCount,
  detailsData,
  profileData,
}) => {
  const { extraFields } = useExtraFieldsContext();

  // const getPrivilegeCardField = (privilegeCard) => {
  //   return confirmFlightLocationUrl ? (
  //     <InputField placeholder="Enter ID number" />
  //   ) : (
  //     <TextFont fontColor={Colors.shark} fontSize="1rem" fontWeight="600">
  //       {privilegeCard ? privilegeCard : "NA"}
  //     </TextFont>
  //   );
  // };

  // const getTextData = (data) => {
  //   return (
  //     <TextFont fontColor={Colors.shark} fontSize="1rem">
  //       {data}
  //     </TextFont>
  //   );
  // };

  // const columns = [
  //   {
  //     path: "passengerName",
  //     label: "Passenger",
  //     content: (data) => getTextData(data.passengerName),
  //   },
  //   {
  //     path: "contactNumber",
  //     label: "Contact Number",
  //     content: (data) => getTextData(data.contactNumber),
  //   },
  //   {
  //     path: "passport",
  //     label: "Passport",
  //     content: (data) => getTextData(data.passport),
  //   },
  //   {
  //     path: "passportExpiry",
  //     label: "Passport Expiry",
  //     content: (data) => getTextData(data.passportExpiry),
  //   },
  //   {
  //     path: "privilegeCard",
  //     label: "Privilege card (Optional)",
  //     content: (data) => getPrivilegeCardField(data.privilegeCard),
  //   },
  // ];

  // const data = [
  //   {
  //     passengerName: "Wasim Yousuf Rahiman",
  //     contactNumber: "+974 56678243",
  //     passport: "XYZ1234567",
  //     passportExpiry: "22 Jan 2028",
  //     isGuest: false,
  //   },
  //   {
  //     passengerName: "Amina Wasim",
  //     contactNumber: "+974 56678243",
  //     passport: "ABC1234567",
  //     passportExpiry: "06 Mar 2026",
  //     isGuest: false,
  //   },
  // ];

  // const guestData = [
  //   {
  //     passengerName: "Mostafa Farag",
  //     contactNumber: "+974 54358872",
  //     passport: "ACD1234567",
  //     passportExpiry: "18 Dec 2030",
  //     isGuest: true,
  //     privilegeCard: "QATARAIR1234",
  //   },
  // ];

  return (
    <>
      <HeaderWrapper>
        <TextFont fontColor={Colors.white} fontSize="1.5rem" fontWeight="800">
          Traveller Details
        </TextFont>
      </HeaderWrapper>
      <Box boxPadding="1.875rem 1.875rem 1.25rem">
        {/* <Table
            columns={columns}
            data={data}
            columnFontColor={Colors.brandTwo}
            columnFontWeight="600"
            fixedLayout
          />
        {guestTicketCount > 0 && (
          <>
            <HorizontalLine />
            <Table
              data={guestData}
              columns={columns}
              headerHidden
              fixedLayout
            />
          </>
        )} */}
        <ColumnWrapper>
          {detailsData?.membersInfo?.map((eachData, i) => {
            return (
              <ConfirmRequestAccordion
                key={i}
                data={{
                  ...getFormattedTravellerDetails(eachData),
                  // phone: profileData?.data?.phoneNumber,
                  travelType:
                    detailsData?.travelDetails?.length > 0
                      ? detailsData?.travelDetails[0]?.travelType
                      : "-",
                }}
              />
            );
          })}
        </ColumnWrapper>
      </Box>
    </>
  );
};

// const HorizontalLine = styled.hr`
//   margin: 1.438rem 0rem 1.188rem;
//   opacity: 0.1;
//   border: 1px solid ${Colors.black};
// `;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.635rem;
`;

export default TravellerDetails;
